export const OFFICE_MIME_TYPES = {
    WORD_DOC: 'application/msword',
    WORD_DOCX:
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    EXCEL_XLS: 'application/vnd.ms-excel',
    EXCEL_XLSX:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    POWERPOINT_PPT: 'application/vnd.ms-powerpoint',
    POWERPOINT_PPTX:
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
};

export const OFFICE_EXTENSIONS = {
    WORD_DOC: 'doc',
    WORD_DOCX: 'docx',
    EXCEL_XLS: 'xls',
    EXCEL_XLSX: 'xlsx',
    POWERPOINT_PPT: 'ppt',
    POWERPOINT_PPTX: 'pptx',
};

export const PDF_MIME_TYPE = 'application/pdf';
export const PDF_EXTENSION = 'pdf';

export const MEDIA_CONFIG = {
    image: {
        mimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'],
        extensions: ['jpg', 'jpeg', 'png', 'gif'],
    },
    video: {
        mimeTypes: ['video/mp4', 'video/avi'],
        extensions: ['mp4', 'avi'],
    },
    audio: {
        mimeTypes: ['audio/mp3', 'audio/ogg', 'audio/mp4'],
        extensions: ['mp3', 'ogg'],
    },
    sticker: {
        mimeTypes: ['image/webp'],
        extensions: ['webp'],
    },
    document: {
        mimeTypes: [
            PDF_MIME_TYPE,
            OFFICE_MIME_TYPES.WORD_DOC,
            OFFICE_MIME_TYPES.WORD_DOCX,
            OFFICE_MIME_TYPES.EXCEL_XLS,
            OFFICE_MIME_TYPES.EXCEL_XLSX,
            OFFICE_MIME_TYPES.POWERPOINT_PPT,
            OFFICE_MIME_TYPES.POWERPOINT_PPTX,
        ],
        extensions: [
            PDF_EXTENSION,
            OFFICE_EXTENSIONS.WORD_DOC,
            OFFICE_EXTENSIONS.WORD_DOCX,
            OFFICE_EXTENSIONS.EXCEL_XLS,
            OFFICE_EXTENSIONS.EXCEL_XLSX,
            OFFICE_EXTENSIONS.POWERPOINT_PPT,
            OFFICE_EXTENSIONS.POWERPOINT_PPTX,
        ],
    },
    unknown: {
        mimeTypes: [],
        extensions: [],
    },
};

export const MIME_TO_EXTENSION_MAP: Record<string, string> = {
    [OFFICE_MIME_TYPES.WORD_DOC]: OFFICE_EXTENSIONS.WORD_DOC,
    [OFFICE_MIME_TYPES.WORD_DOCX]: OFFICE_EXTENSIONS.WORD_DOCX,
    document: OFFICE_EXTENSIONS.WORD_DOCX,
    [OFFICE_MIME_TYPES.EXCEL_XLS]: OFFICE_EXTENSIONS.EXCEL_XLS,
    [OFFICE_MIME_TYPES.EXCEL_XLSX]: OFFICE_EXTENSIONS.EXCEL_XLSX,
    sheet: OFFICE_EXTENSIONS.EXCEL_XLSX,
    [OFFICE_MIME_TYPES.POWERPOINT_PPT]: OFFICE_EXTENSIONS.POWERPOINT_PPT,
    [OFFICE_MIME_TYPES.POWERPOINT_PPTX]: OFFICE_EXTENSIONS.POWERPOINT_PPTX,
    presentation: OFFICE_EXTENSIONS.POWERPOINT_PPTX,
};

export type MediaType =
    | 'image'
    | 'video'
    | 'audio'
    | 'sticker'
    | 'document'
    | 'unknown';

export const IMAGE_TYPE = MEDIA_CONFIG.image.mimeTypes;
export const VIDEO_TYPE = MEDIA_CONFIG.video.mimeTypes;
export const AUDIO_TYPE = MEDIA_CONFIG.audio.mimeTypes;
export const STICKER_TYPE = MEDIA_CONFIG.sticker.mimeTypes;

export const IMAGE_EXTENSIONS = MEDIA_CONFIG.image.extensions;
export const VIDEO_EXTENSIONS = MEDIA_CONFIG.video.extensions;
export const AUDIO_EXTENSIONS = MEDIA_CONFIG.audio.extensions;
export const STICKER_EXTENSIONS = MEDIA_CONFIG.sticker.extensions;

export const DONT_SUPPORT_UPLOAD_MEDIA_TYPE =
    'Your browser does not support the multimedia type.';
